import Vue from 'vue';

export default {
   SET_PAGE_HEADER: (state, data) => {
      Vue.set(state, 'headerData', data);
   },
   SET_HOME_PAGE_DATA: (state, { data }) => {
      Vue.set(state, 'homePageData', data);
   },

   SET_CHINESE_HOME_PAGE_DATA: (state, { data }) => {
      Vue.set(state, 'chineseHomePageData', data);
   },

   SET_EXTENSION_PAGE_DATA: (state, { data }) => {
      Vue.set(state, 'extensionPageData', data);
   },
   SET_RESOURCE_PAGE_DATA: (state, { data }) => {
      Vue.set(state, 'resourcePageData', data);
   },
   SET_RESOURCE_SLUG_PAGE_DATA: (state, { data }) => {
      Vue.set(state, 'resourceSlugPageData', data);
   },
   SET_WHITEPAPER_PDF_SLUG_PAGE_DATA_FETCH: (state, { data }) => {
      Vue.set(state, 'whitepaperPdfSlugPageData', data);
   },
   SET_DASHBOARD_PAGE_DATA: (state, { data }) => {
      Vue.set(state, 'dashboardPageData', data);
   },
   SET_DASHBOARD_SLUG_PAGE_DATA: (state, { data }) => {
      Vue.set(state, 'dashboardetailPageData', data);
   },
   SET_CUSTOMER_PAGE_DATA: (state, { data }) => {
      Vue.set(state, 'customerPageData', data);
   },
   SET_PRESS_PAGE_DATA: (state, { data }) => {
      Vue.set(state, 'pressPageData', data);
   },
   SET_CUSTOMER_SLUG_PAGE_DATA: (state, { data }) => {
      Vue.set(state, 'customerSlugPageData', data);
   },
   SET_PLUGINS_SLUG_PAGE_DATA: (state, { data }) => {
      Vue.set(state, 'pluginsSlugPageData', data);
   },
   SET_DOWNLOAD_PAGE_DATA: (state, { data }) => {
      Vue.set(state, 'downloadPageData', data);
   },
   SET_NAVBAR_NAVIGATION_DATA: (state, { data, stateName }) => {
      Vue.set(state, stateName, data);
   },
   SET_FUSIONCHARTS_DATASOURCE: (state, { key, data }) => {
      Vue.set(state, key, data);
   },
   SET_PLAYGROUND_DATA: (state, { data }) => {
      Vue.set(state, 'playgroundData', data);
   },
   SET_PLAYGROUND_CODE: (state, { data }) => {
      Vue.set(state.playgroundData.code, 'display', data.display);
   },
   SET_PRICING_DATA: (state, { data }) => {
      Vue.set(state, 'pricingPageData', data);
   },
   SET_SUPPORT_DATA: (state, { data }) => {
      Vue.set(state, 'supportPageData', data);
   },
   // SET_PROMOTIONAL_DATA: (state, { data }) => {
   //    Vue.set(state, 'promotionalData', data);
   // },
   SET_EULA_PERPETUAL_PRICING_DATA: (state, { data }) => {
      Vue.set(state, 'eulaPerpetualPageData', data);
   },
   SET_PRIVACY_POLICY_DATA: (state, { data }) => {
      Vue.set(state, 'privacyPolicyPageData', data);
   },
   SET_RESELLERS_FAQ_DATA: (state, { data }) => {
      Vue.set(state, 'ResellersFaqsPageData', data);
   },
   SET_CONTACT_US_DATA: (state, { data }) => {
      Vue.set(state, 'contactUsPage', data);
   },
   SET_CONTACT_SALES_DATA: (state, { data }) => {
      Vue.set(state, 'contactSalesPage', data);
   },
   SET_NEWSLETTER_DATA: (state, { data }) => {
      Vue.set(state, 'newsletterPage', data);
   },
   SET_CONTACT_SUPPORT_DATA: (state, { data }) => {
      Vue.set(state, 'contactSupportPage', data);
   },
   SET_DATA_STORIES_OVERVIEW_PAGE_DATA: (state, { data }) => {
      Vue.set(state, 'dataStoriesOverviewPage', data);
   },
   SET_DATA_STORIES_PAGE_DATA: (state, { data }) => {
      Vue.set(state, 'dataStoriesPage', data);
   },
   SET_PLAYGROUND_SIDEBAR_DATA: (state, { data }) => {
      Vue.set(state, 'playgroundSidebarData', data);
   },
   SET_INTEGRATIONS_DATA: (state, { data }) => {
      Vue.set(state, 'integrationsData', data);
   },
   SET_INTEGRATIONS_CODE: (state, { data, tab }) => {
      Vue.set(state.integrationsData.tabs[tab], 'code', data.code);
   },
   SET_PARTNERS_DATA: (state, { data }) => {
      Vue.set(state, 'partnersData', data);
   },
   SET_FUSIONEXPORT_DATA: (state, { data }) => {
      Vue.set(state, 'fusionExportData', data);
   },
   SET_COMPARISIONOVERVIEW_DATA: (state, { data }) => {
      Vue.set(state, 'comparisonOverview', data);
   },
   SET_OVERVIEW_DATA: (state, { data }) => {
      Vue.set(state, 'overviewData', data);
   },

   SET_CHARTS_TYPE_OVERVIEW_DATA: (state, { data }) => {
      Vue.set(state, 'overviewChartsTypeData', data);
   },
   SET_OVERVIEW_INTEGRATIONS_DATA: (state, { data }) => {
      Vue.set(state, 'overviewIntegrationsData', data);
   },
   SET_OVERVIEW_ACCESSIBILITY_DATA: (state, { data }) => {
      Vue.set(state, 'overviewAccessibilityData', data);
   },
   SET_ACCESSIBILITY_SLUG_PAGE_DATA: (state, { data }) => {
      Vue.set(state, 'AccessibilitySlugData', data);
   },
   SET_RESOURCE_PAGE_SIDE_NAVIGATION_DATA: (state, { data }) => {
      Vue.set(state, 'resourcesSideNavData', data);
   },

   SET_RESELLERS_PAGE_DATA: (state, { data }) => {
      Vue.set(state, 'ResellersPageData', data);
   },
   SET_RESELLER_SLUG_PAGE_DATA: (state, { data }) => {
      Vue.set(state, 'resellerSlugPageData', data);
   },
   SET_RESELLER_DATA: (state, { data }) => {
      Vue.set(state, 'resellerData', data);
   },
   SET_STATIC_DATA: (state, { data }) => {
      Vue.set(state, 'staticPageData', data);
   },
   SET_MAPS_PAGE_DATA: (state, { data }) => {
      Vue.set(state, 'playgroundData', data);
   },
   SET_ALLMAPS_DATA: (state, { data }) => {
      Vue.set(state, 'allMapsPageData', data);
   },
   SET_ABOUT_PAGE_DATA: (state, { data }) => {
      Vue.set(state, 'aboutPageData', data);
   },
   SET_COMPARISON_PAGE_DATA: (state, { data }) => {
      Vue.set(state, 'comparisonPageData', data);
   },
   SET_ROUTE_PROP: (state, { data }) => {
      Vue.set(state, 'routeProp', data);
   },
   SET_PAGE_JSON_SCHEMA: (state, { data }) => {
      Vue.set(state, 'pageJsonSchema', data);
   },
   SET_CAREERS_PAGE_DATA: (state, { data }) => {
      Vue.set(state, 'careersPageData', data);
   },
   SET_TEAM_PAGE_DATA: (state, { data }) => {
      Vue.set(state, 'teamPageData', data);
   },
   SET_FEATURE_GALLERY_PAGE_DATA: (state, { data }) => {
      Vue.set(state, 'featureGalleryOverview', data);
   },

   SET_FEATURE_GALLERY_DETAILED_SLUG_PAGE_DATA: (state, { data }) => {
      Vue.set(state, 'FeatureGalleryDetailedSlugData', data);
   },

   SET_CHART_GUIDE_SLUG_PAGE_DATA: (state, { data }) => {
      Vue.set(state, 'chartGuideSlugPageData', data);
   },

   SET_TIME_SERIES_PAGE_DATA: (state, { data }) => {
      Vue.set(state, 'fusionTimeLandingData', data);
   },

   SET_FUSIONTIME_EXAMPLES_DATA: (state, { data }) => {
      Vue.set(state, 'fusionTimeExamplesData', data);
   },

   SET_FUSIONTIME_DETAILS_DATA: (state, { data }) => {
      Vue.set(state, 'playgroundData', data);
   },

   SET_SIDEBAR_FLAG: (state, { data }) => {
      Vue.set(state, 'isSidebarTreeEnable', data);
   },

   SET_BANNER_FLAG: (state, { data }) => {
      Vue.set(state, 'bannerAvailable', data);
   },
   SET_NONCOMMERCIAL_DATA: (state, { data }) => {
      Vue.set(state, 'noncommercialPageData', data);
   },

   SET_PRODUCT_GALLERY_DATA: (state, { data }) => {
      Vue.set(state, 'productGalleryPageData', data);
   },

   SET_ADMIN_VIEW: (state, { data }) => {
      Vue.set(state, 'adminView', data);
   },

   SET_ADMIN_CONFIGURATION: (state, { data }) => {
      Vue.set(state, 'adminBasicConfig', data);
   },

   SET_COMPARISON_DETAILED_PAGE_DATA: (state, { data }) => {
      Vue.set(state, 'comparisonDetailedPageData', data);
   },
   SET_COMPARISON_NEW_DETAILED_PAGE_DATA: (state, { data }) => {
      Vue.set(state, 'comparisonNewDetailedPageData', data);
   },
   SET_OVERVIEW_FUSIONGRID_PAGE_DATA: (state, { data }) => {
      Vue.set(state, 'fusiongridLandingData', data);
   },
   SET_FUSIONGRID_PAGE_DATA: (state, { data }) => {
      Vue.set(state, 'fusionGridData', data);
   },
   SET_FUSION_GRID_DETAILS_FETCH: (state, { data }) => {
      Vue.set(state, 'fusionGridDetailData', data);
   },
   // each mutation have state and params sent from actions
   SET_FC_VS_OTHERS_COMPARISON_PAGE_DATA: (state, { data, slug }) => {
      //  console.log('==============Mutation', slug, data);
      Vue.set(state, slug, data);
   },
};
